import React from "react";
import styles from "../component/custom.module.css";
import Images from "./Images";
import Nav from "../component/Nav";
import Modal from "react-modal";
import { useState } from "react";
import { useMediaQuery } from "../hooks/useMediaQuery";

const mainPost = {
  video_url: "https://www.youtube.com/embed/i334JTo1F3Q",
  author: {
    name: "Salim Merchant",
    bio: "Score composer, Music director",
  },
};

const Banner = ({ executeScroll }) => {
  // modal
  const [modalIsOpen, setIsOpen] = useState(false);
  
  const [videoUrl, setVideoUrl] = useState(mainPost.video_url);
  function openModal(videoUrlSrc) {
    setVideoUrl(videoUrlSrc);
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }
  // Modal

  return (
    <section className={styles.BannerSection}>
      <div className="container-fluid">
        
        <button
          href="#"
          data-event-id="register"
          className={`${styles.commonBtn}`}
          onClick={executeScroll}
        >
          register now
        </button>
        
        <Modal
          style={{
            content: {
              display: "flex",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              borderWidth: 0,
              flexDirection: "column",
              flex: 1,
              position: "unset",
              height: "100%",
              overflow: "auto",
              justifyContent: "center",
            },
          }}
          // overlayClassName={Modalstyle.modal}
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Example Modal"
        >
          <div className="container">
            <div className={styles.modalVideo}>
              <img
                className={styles.modalClose}
                src={Images.Cancel}
                onClick={closeModal}
              />
              {modalIsOpen && (
                <iframe
                  width="100%"
                  height="394"
                  src={videoUrl + "?&autoplay=1&rel=0"}
                  title="Video"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              )}
            </div>
          </div>
        </Modal>
      </div>
    </section>
  );
};

export default Banner;
